import React from 'react';
import { Link } from 'react-router-dom';

const galleryImages = [
  { url: 'https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=600&q=80', title: 'Grilled Perfection' },
  { url: 'https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?w=600&q=80', title: 'Kebab Art' },
  { url: 'https://images.unsplash.com/photo-1580217593608-61931cefc821?w=600&q=80', title: 'Fresh Catch' },
  { url: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80', title: 'Our Space' },
  { url: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80', title: 'Plated Beauty' },
  { url: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=600&q=80', title: 'Fine Dining' },
];

const GalleryPreview = () => (
  <section className="section-padding" style={{ backgroundColor: '#faf8f5' }}>
    <div className="container">
      <div className="text-center mb-5 reveal">
        <span className="section-subtitle">Visual Journey</span>
        <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600 }}>
          Our Gallery
        </h2>
        <div className="gold-divider-center"></div>
      </div>

      <div className="row g-3 reveal">
        {galleryImages.map((img, index) => (
          <div key={index} className="col-6 col-md-4">
            <div className="img-zoom hover-lift" style={{ borderRadius: '12px', overflow: 'hidden', position: 'relative', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
              <img src={img.url} alt={img.title} style={{ height: '250px', objectFit: 'cover', width: '100%', display: 'block' }} loading="lazy" />
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                padding: '30px 16px 14px',
                opacity: 0, transition: 'opacity 0.3s ease'
              }} className="gallery-overlay">
                <span className="text-white" style={{ fontSize: '0.9rem', fontWeight: 500 }}>{img.title}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-5 reveal">
        <Link to="/gallery" className="btn btn-outline-gold" style={{ padding: '14px 36px' }}>
          View All Gallery
        </Link>
      </div>
    </div>
  </section>
);

export default GalleryPreview;
